exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".graphic-space{margin-top:60px}", "", {"version":3,"sources":["/app/src/components/dashboards/Dashboard.vue"],"names":[],"mappings":"AACA,eACE,eAAiB,CAClB","file":"Dashboard.vue","sourcesContent":["\n.graphic-space {\n  margin-top: 60px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4f8e9a6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboards/Dashboard.vue
// module id = 510
// module chunks = 5